import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  editFromId,
  newItem
} from '../../API/TransatelDataRecharges';
import { form } from '../Form/transatelDataRecharge';
import { form as searchForm } from '../Form/Search/transatelDataRecharge';

import { transatelDataRecharge as routes } from '../Route/routes';

export const conf = {
  index: {
    id: "transatelDataRecharge",
    pageTitle: strings.common.homepage.transatelDataRecharge,
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    newLink: {
      link: () => routes.routes.new.createPath(),
      auth: 'ROLE_MVNO_CONFIGURATION'
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(typeof search.transatelPreviousThreshold === 'object') {
        result["transatel_previous_threshold_id"] = search.transatelPreviousThreshold.id;
      }
      return result;
    },

    availableItemDisplay:['line', 'tab'],
    itemDisplay: {
      line: {
        label: (item) => item["transatel_previous_threshold"].name + " > " + item["transatel_next_threshold"].name + " > " + item["product"].name,
      },
      tab: {
        headers: [
          {
            label: "Palier précédent",
            value: (item) => item["transatel_previous_threshold"]["name"]
          },
          {
            label: "Palier suivant",
            value: (item) => item["transatel_next_threshold"]["name"]
          },
          {
            label: "Produit correspondant",
            value: (item) => item["product"]["name"]
          }
        ]
      }
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },

    buttons: (item) => []
  },
  show: {
    pageTitle: strings.common.homepage.transatelDataRecharge,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "number",

    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.transatelDataRecharge.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (item, extraValues) => {},
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_MVNO_CONFIGURATION'],
        editable: ['ROLE_MVNO_CONFIGURATION']
      }
    }
  },
  new: {
    pageTitle: strings.transatelDataRecharge.new.title,

    api: newItem,
    empty: {},
    form: form,
    onSubmit: (item, extraValues) => {},
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
